import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from '../../../../types/ReportResult';
import {MaterialOrderReportType} from '../types/MaterialOrderReportType';

export async function apiGenerateMaterialOrderReport(materialOrderID: number, reportType: MaterialOrderReportType): Promise<ReportResult> {
    try {
        return await apiClient.get("report/material-order",
            {
                params:
                {
                    materialOrderID: materialOrderID,
                    reportType: reportType
                }
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
